/**
 * Created by koqiui on 2017-04-12.
 */
import api from './index'

let exports = {};
//
exports.getCallBidDocList = function (data, callback) {// 获取招标书列表
    api.post('/callBid/doc/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 申请
exports.applyCallBidDoc = function (data, callback) {// 招标书申请
    api.post('/callBid/doc/apply/do')
    .data(data)
    .done(callback)
    .go();
};
// 审核
exports.auditCallBidDoc = function (data, callback) {// 审核招标书
    api.post('/callBid/doc/audit/do')
    .data(data)
    .done(callback)
    .go();
};
// 发布
exports.publishCallBidDoc = function (data, callback) {// 发布招标书
    api.post('/callBid/doc/publish/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取招标书信息
exports.getCallBidDocInfo = function (data, callback) {// 获取招标书详细信息
    api.post('/callBid/doc/info/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取招标书信息
exports.getCallBidDocInfoForStaffQuali = function (data, callback) {// 获取招标书-中 要求的人员资质
    api.post('/callBid/doc/info/for/staff/quali/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取招标书数量
exports.getCallBidDocNumber = function (callback) {// 获取招标书数量
    api.post('/callBid/doc/number/get')
    .done(callback)
    .go();
};

exports.createCallBidDoc = function (data, callback) {// 创建招标书
    api.post('/callBid/doc/create/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateCallBidDocSrc = function (data, callback) {// 更新招标书来源
    api.post('/callBid/doc/src/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 流标
exports.abortCallBidDoc = function (data, callback) {// 流标
    api.post('/callBid/doc/abort/do')
    .data(data)
    .done(callback)
    .go();
};

// 招标商务条款
exports.getCallBidTermList = function (data, callback) {// 获取招标书列表
    api.post('/callBid/term/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 招标商品
exports.getCallBidGoodsList = function (data, callback) {// 获取招标书商品列表
    api.post('/callBid/goods/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 招标服务
exports.getCallBidServcList = function (data, callback) {// 获取招标书服务列表
    api.post('/callBid/servc/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 招标资质
exports.getCallBidReqQualiList = function (data, callback) {// 获取招标书资质列表
    api.post('/callBid/req/quali/list/get')
    .data(data)
    .done(callback)
    .go();
};

//查看招标公告
exports.getCallBidNotice = function (params, callback) {// 获取招标公告
    api.get('/callBid/notice/get')
    .params(params)
    .done(callback)
    .go();
};

//招标公告模板
exports.getCallBidNoticePreviewText = function (data, callback) {// 获取招标公告模板预览
    api.post('/callBid/notice/preview/text/get')
    .data(data)
    .done(callback)
    .go();
};

//查询招标公告数量
exports.getCallBidNoticeCountByDocId = function (params, callback) {// 根据招标书id获取招标公告数量
    api.get('/callBid/notice/count/get/by/docId')
    .params(params)
    .done(callback)
    .go();
};

//是否含有招标公告
exports.saveCallBidNotice = function (data, callback) {// 保存招标公告
    api.post('/callBid/notice/save/do')
    .data(data)
    .done(callback)
    .go();
};

//查询未发布的招标公告
exports.getCallBidNoticeByDocIdAndPublished = function (data, callback) {// 根据招标书id和已发布状态获取招标书
    api.post('/callBid/notice/get/by/docId/and/published')
    .data(data)
    .done(callback)
    .go();
};

//根据docId查询招标公告
exports.getCallBidNoticeListByDocId = function (params, callback) {// 根据docid获取招标公告列表
    api.get('/callBid/notice/list/get/by/docId')
    .params(params)
    .done(callback)
    .go();
};

//根据id删除招标公告
exports.deleteCallBidNotice = function (params, callback) {// 删除招标公告
    api.post('/callBid/notice/delete/do')
    .params(params)
    .done(callback)
    .go();
};

//发布招标公告
exports.publishCallBidNotice = function (postData, callback) {// 发布招标公告
    api.post('/callBid/notice/publish/do')
    .data(postData)
    .done(callback)
    .go();
};

//投标审核列表
exports.getBidDocAuditList = function (postData, callback) {// 发布招标公告
    api.post('/callBid/audit/list/get')
    .data(postData)
    .done(callback)
    .go();
};

///取消招标来源
exports.cancelCallBidDocSrc = function (postParam, callback) {// 更新询价单
    api.post('/callBid/src/cancel/do')
    .params(postParam)
    .done(callback)
    .go();
};

///招标书操作记录
exports.getCallBidActRecByDocId = function (postParam, callback) {// 更新询价单
    api.post('/callBid/doc/act/rec/list/get')
    .params(postParam)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/callBid.js
// module id = 76
// module chunks = 0